import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "grey-form-card" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-parent" }, [
    /*#__PURE__*/_createVNode("h6", { class: "small-grey" }, "SiteUsers")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
}